import { render, staticRenderFns } from "./WishlistDialog.vue?vue&type=template&id=eed223c6&"
import script from "./WishlistDialog.vue?vue&type=script&lang=js&"
export * from "./WishlistDialog.vue?vue&type=script&lang=js&"
import style0 from "./WishlistDialog.vue?vue&type=style&index=0&id=eed223c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports